// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cu-j";
export var fulfillmentFormRail = "_cu-i";
export var headerTitleRow = "_cu-l";
export var orderDetailsWrapper = "_cu-g";
export var orderLinkTrigger = "_cu-2";
export var paymentInformationGrid = "_cu-q";
export var paymentSummaryColumn = "_cu-r";
export var phoneShipmentPickerButton = "_cu-e";
export var phoneShipmentPickerButtonContent = "_cu-f";
export var phoneShipmentPickerButtonWrapper = "_cu-d";
export var phoneShipmentPickerTrigger = "_cu-c";
export var shipmentContainer = "_cu-k";
export var shipmentDetailsMainPane = "_cu-h";
export var shipmentNavigationCard = "_cu-a";
export var shipmentNavigationEdgeTrigger = "_cu-6";
export var shipmentNavigationRail = "_cu-3";
export var shipmentNavigationRailEnter = "_cu-5";
export var shipmentNavigationRailHeader = "_cu-9";
export var shipmentNavigationRailOverlay = "_cu-4";
export var shipmentNavigationScrim = "_cu-7";
export var shipmentSummaryFact = "_cu-n";
export var shipmentSummaryGrid = "_cu-m";
export var shipmentSummaryMetadataRow = "_cu-o";
export var shipmentSummaryTags = "_cu-p";
export var shipmentWorkspace = "_cu-0";
export var shipmentWorkspaceBodyTablet = "_cu-8";
export var shipmentWorkspaceContent = "_cu-b";
export var shipmentWorkspaceHeader = "_cu-1";